var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",style:(_vm.avatarStyle)},[(_vm.showImage)?_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.avatar,"alt":_vm.displayName,"title":_vm.displayName},on:{"error":_vm.handleImageError}}):_c('span',{staticClass:"avatar-fallback",style:(_vm.fallbackStyle)},[_vm._v(_vm._s(_vm.initial))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acafe380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/UserAvatar.vue
// module id = null
// module chunks = 